import type { LabelHTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  isPageHeading?: boolean;
  children: ReactNode;
}

/** govuk/components/label */
export function Label({ isPageHeading, className, children, htmlFor, ...rest }: LabelProps) {
  const label = (
    <label className={cx('govuk-label', className)} htmlFor={htmlFor} {...rest}>
      {children}
    </label>
  );
  if (isPageHeading) {
    return (
      <h1 className="govuk-label-wrapper" tabIndex={-1}>
        {label}
      </h1>
    );
  }
  return label;
}
